<div class="app-container" *ngIf="!isFOSSACLoading">
  <!-- <button mat-raised-button (click)="changeLanguage()" class="mb-1 lang-button">{{ language[currentLanguage]['changeTo'] }}</button> -->
  <div class="language-switcher" [ngClass]="{ 'gradient-border-animate in': !isLanguageSelected }">
    <app-select placeHolder="Select language"
    [group]="languageForm"
    [control]="language"
    appearance="fill"
    (onChange)="selectLanguage($event)"
    [data]="languages">
    </app-select>
  </div>
  <app-card-view cardClass="full-card">
    <mat-card-header class="card-title">
      {{ stageOtp ? formInfo?.verify_mobile : formInfo?.start_your_fundraiser }}
    </mat-card-header>
    <hr _ngcontent-c4="" class="line">
    <mat-card-content *ngIf="!stageOtp">
      <form class="form-container zindex-neg form m-10" [formGroup]="form" (ngSubmit)="signup('firstForm')" autocomplete="off">
        <div [hidden]="hideNGO">
          <app-sac-purpose [frType]="purpose" (selectionChangeEvent)="purposeSelectionEvent($event)"
          [currentLanguage]="currentLanguage" [formInfo]="formInfo"></app-sac-purpose >
        </div>
        <div class="mt-2">
          <app-input
            [group]="form"
            [control]="name"
            [placeHolder]="formInfo.names.placeholder"
            [errorMessage]="formInfo.names.error"
            [info]="false"
            icon="icon-user"
            [hint]="formInfo.names.hint"
            [fieldRequired]="formInfo.fieldRequired"
            hintDirection="start">
          </app-input>
        </div>
        <div class="mt-1">
          <app-input
            [group]="form"
            [control]="email"
            [placeHolder]="formInfo.email.placeholder"
            [errorMessage]="formInfo.email.error"
            [info]="false"
            [fieldRequired]="formInfo.fieldRequired"
            icon="icon-mail">
          </app-input>
        </div>
        <div class="mt-1">
          <app-password
            [group]="form"
            [control]="password"
            [placeHolder]="formInfo.password.placeholder"
            [errorMessage]="formInfo.password.error"
            [fieldRequired]="formInfo.fieldRequired"
            >
          </app-password>
        </div>
        <div class="mt-1">
          <app-intl-input
            class="intl-input-container"
            [group]="form"
            [control]="mobile"
            [hideSuffixIcon]="false"
            [placeholder]="formInfo.mobile.placeholder"
            [validNoErr]="formInfo.validPhNo"
            [checkCountry]="dockFrData && dockFrData !== null ? false: true">
          </app-intl-input>
        </div>
        <app-captcha-input [control]="captcha" type="dialog" size="invisible" #captchaSignUp></app-captcha-input>
        <button id="submitBtn1" style="display: none" ></button>
      </form>
    </mat-card-content>
    <mat-card-content *ngIf="stageOtp && !acceptedTrueCallerAuth && switchEmailLogin">
      <form class="form-container zindex-neg form m-10" [formGroup]="otpForm" (ngSubmit)="signup('secondForm')" autocomplete="off">
        <div class="mt-2" style="position: relative;">
          <app-input
            [group]="form"
            [control]="email"
            [placeHolder]="formInfo.email.placeholder"
            [errorMessage]="formInfo.email.error"
            [info]="false"
            [fieldRequired]="formInfo.fieldRequired"
            icon="icon-mail"
            [readonly]="true">
          </app-input>
        </div>
        <div class="mt-2" style="position: relative;">
          <!-- <div class="email-otp">A verification OTP sent to the email <a href="mailto:{{form.value.email}}">{{form.value.email}}</a></div> -->
          <span *ngIf="!isLoading" class="get-otp" (click)="verifyUserExist('email')" style="top: 20px;cursor: pointer;z-index: 1;">
            {{formInfo?.get_otp}}
          </span>
          <app-input
            [group]="otpForm"
            [control]="email_otp"
            [placeHolder]="formInfo.otp.placeholder"
            [errorMessage]="formInfo.otp.error"
            [info]="false"
            [fieldRequired]="formInfo.fieldRequired"
            hintDirection="start">
          </app-input>
        </div>
        <app-captcha-input [control]="captcha" type="dialog" size="invisible" #captchaSignUp></app-captcha-input>
        <button id="submitBtn1" style="display: none" ></button>
      </form>
    </mat-card-content>
    <mat-card-content *ngIf="stageOtp && !acceptedTrueCallerAuth && !switchEmailLogin">
      <form class="form-container zindex-neg form m-10" [formGroup]="otpForm" (ngSubmit)="signup('secondForm')" autocomplete="off">
        <div class="mt-2" style="position: relative;">
          <div class="mt-1">
            <app-intl-input
              class="intl-input-container"
              [group]="otpForm"
              [control]="mobile"
              [hideSuffixIcon]="true"
              [placeholder]="formInfo.mobile.placeholder"
              [validNoErr]="formInfo.validPhNo"
              [checkCountry]="dockFrData && dockFrData !== null ? false: true">
            </app-intl-input>
            <span class="get-otp" (click)="getOTPfromFirebasePhone('resend')">
              {{formInfo.get_otp}}
            </span>
          </div>
          <app-input
            [group]="otpForm"
            [control]="otp"
            [placeHolder]="formInfo.otp.placeholder"
            [errorMessage]="formInfo.otp.error"
            [info]="false"
            [fieldRequired]="formInfo.fieldRequired"
            hintDirection="start">
          </app-input>
        </div>
        <app-captcha-input [control]="captcha" type="dialog" size="invisible" #captchaSignUp></app-captcha-input>
        <button id="submitBtn1" style="display: none" ></button>
      </form>
    </mat-card-content>
    <mat-card-footer class="fund-button-container">
      <div class="text-center mb-2" *ngIf="!stageOtp">{{formInfo.exisiting_account}} <span class="style-as-link" (click)="openSigninPopup()">{{formInfo.login}}</span></div>
      <app-captcha></app-captcha>
      <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()" [disabled]="isLoading">
        <div class="button-wrapper" *ngIf="!isLoading" >
          {{ formInfo?.next }}
        </div>
        <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
    </mat-card-footer>
  </app-card-view>
  <div class="ngo-sign-up mt-5 text-center" [hidden]="hideNGO">
    {{ formInfo?.are_you_an_ngo }}
     <a href="https://survey.zohopublic.com/zs/2MB3IB" target="blank" class="style-as-link"> {{ formInfo?.apply_here }} </a>
  </div>
</div>
<mat-spinner class="text-center" *ngIf="isFOSSACLoading" [diameter]="50"></mat-spinner>

<ng-template #askEmail>
  <div class="dialog-container">
    <button class="close" (click)="closeDialog()" mat-icon-button>
      <i class="material-icons">close</i>
    </button>
    <form [formGroup]="emailForm" (ngSubmit)="verifyEmail()">
      <div class="input-email">
        <app-input
          [group]="form"
          [control]="emailCheck"
          [placeHolder]="formInfo.email.placeholder"
          [errorMessage]="formInfo.email.error"
          [info]="false"
          [fieldRequired]="formInfo.fieldRequired"
          icon="icon-mail">
        </app-input>
      </div>
      <button mat-raised-button class="okay" type="submit" color="primary" [disabled]="isLoadingEmail">
        <div class="button-wrapper" *ngIf="!isLoadingEmail" >
          OKAY
        </div>
        <div *ngIf="isLoadingEmail" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
      <!-- <button mat-raised-button class="okay">Okay</button> -->
    </form>
  </div>
</ng-template>
